export const lightTheme = {
    bg: "rgb(147,149,152)",
    bgAlpha: "rgb(147,149,152)",
    bg2: "rgb(167,169,172)",
    bg3: "rgb(147,149,152)",
    bgTable: "rgba(91, 107, 103, 1)",
    text: "rgb(45,45,45)",
    select: "rgb(45,45,45)",
    primary: "rgb(52,131,235)",
};

export const darkTheme  = {
    bg: "rgb(21,37,92)",
    bgAlpha: "rgb(21,37,92)",
    bg2: "rgb(41,57,112)",
    bg3: "rgb(21,37,92)",
    bgTable: "rgb(11 25 72)",
    text: "rgb(210,210,210)",
    select: "rgb(45,45,45)",
    primary: "rgb(52,131,235)",
};
